import { action, observable, reaction, makeObservable } from 'mobx';
import {contentLoaders, X6Page, X7PushableBlock} from '../../../domain';
import {arrayToMap, Disposers, HttpPromiseState} from '../../../lib/helpers';

export class X6PageLoader {
  @observable.ref
  state: HttpPromiseState<X6Page> | null;

  @observable.ref
  page: X6Page | null;
  @observable.ref
  pushableBlocks: readonly X7PushableBlock[];
  @observable.ref
  pushableBlockById: { [index: number]: X7PushableBlock };

  private readonly disposers = new Disposers();

  constructor(readonly pageId: number) {
    makeObservable(this);
    this.state = null;
    this.page = null;
    this.pushableBlocks = [];
    this.pushableBlockById = {};
    this.setup();
  }

  setup() {
    this.disposers.add(reaction(
      () => this.state?.state,
      this.onPageLoaded
    ));
  }

  @action
  load = () => {
    if (this.state?.isPending)
      return;
    this.state = contentLoaders.x6page.get(this.pageId);
  };


  @action
  private onPageLoaded = () => {
    this.page = null;
    this.pushableBlocks = [];
    this.pushableBlockById = {};

    if (this.state?.isResolved === true) {
      this.page = this.state.value;
      this.pushableBlocks = this.page.PushableBlocks === null
        ? [] :
        this.page.PushableBlocks;
      this.pushableBlockById = arrayToMap(this.pushableBlocks, x => x.Id);
    }
  };

  dispose = () => {
    this.disposers.dispose();
  };
}
